import '../../../common/dashboard/filters/unapplied/unapplied_filter_view.js.coffee'

Namespace 'CustomerVisualMode.Filters.Unapplied'

FILTERS = Common.Dashboard.Filters

class CustomerVisualMode.Filters.Unapplied.UnappliedGroupsFilterView extends FILTERS.ToggleableUnappliedFilterView
  initialize: ({filter, groups}) ->
    super(filter: filter)
    _.extend(@, CustomerVisualMode.Filters.GroupsFilterMixin)
    @groups = groups

  toggleOpenFilter: ->
    @renderModal(@filter, @groups)

  _displayTitle: ->
    I18n.t('customer_visual_mode.filters.groups')
